import { render, staticRenderFns } from "./add-ad-product.vue?vue&type=template&id=2257bffe&scoped=true&"
import script from "./add-ad-product.vue?vue&type=script&lang=js&"
export * from "./add-ad-product.vue?vue&type=script&lang=js&"
import style0 from "./add-ad-product.vue?vue&type=style&index=0&id=2257bffe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2257bffe",
  null
  
)

export default component.exports